export const BASE_URL = '/players'
export const PLAYER_URL = '/players/player/:playerId'
export const REDUCER_INDEX = 'players'

export const getRouteToPlayerHome = (playerId) => PLAYER_URL.replace(':playerId', playerId)

export const sortPlayers = (a, b) => {
  const fNameA = a.player.first_name
  const lNameA = a.player.last_name
  const keyA = `${lNameA} ${fNameA} ${a.number || ''}`.toLocaleLowerCase()

  const fNameB = b.player.first_name
  const lNameB = b.player.last_name
  const keyB = `${lNameB} ${fNameB} ${b.number || ''}`.toLocaleLowerCase()

  if (keyA < keyB) {
    return -1
  }
  return 1
}
